import { render, staticRenderFns } from "./CardDocuments.vue?vue&type=template&id=0b4ad066"
import script from "./CardDocuments.vue?vue&type=script&lang=js"
export * from "./CardDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports